<template>
  <el-table-column
    :width="editable ? 100 : 50"
    align="center"
    :class-name="editable ? 'editable-row-actions' : ''"
    :fixed="fixed"
  >
    <template slot="header" slot-scope="{}">
      <slot name="header">
        <div v-if="title">{{ title }}</div>
      </slot>
    </template>
    <template slot-scope="scope">
      <div class="actions">
        <rest-list-action-edit
          v-if="editable"
          :index="scope.$index"
          :icon="icon"
          :wrap="wrap"
        >
          <slot :row="scope.row"></slot>
        </rest-list-action-edit>
        <el-dropdown v-else trigger="click" data-qa="hamburger-menu-button">
          <div class="dropdown-btn-wrapper">
            <i :class="icon"></i>
            <el-dropdown-menu slot="dropdown">
              <slot :row="scope.row"></slot>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
    </template>
  </el-table-column>
</template>

<script>
import RestListActionEdit from '@/common/components/rest/RestListActionEdit'
export default {
  name: 'RestListColumnActions',
  components: { RestListActionEdit },
  props: {
    title: {
      type: String,
      required: false
    },

    icon: {
      type: String,
      default: 'el-icon-more',
      required: false
    },

    editable: {
      type: Boolean,
      required: false,
      default: false
    },

    fixed: {
      type: [Boolean, String],
      required: false,
      default: false
    },

    wrap: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>
<style scoped>
.actions .el-icon-more {
  cursor: pointer;
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnActions.vue